module.exports = __webpack_public_path__ + "img/logoCAS1a.9b0dc8a4.png";